module.exports = __webpack_public_path__ + "img/bitcoin.728d7bab.png";